import {
  LegalEntitiesCreateRequestType,
  LegalEntitiesCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useLegalEntityCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: LegalEntitiesCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `legal-entity`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as LegalEntitiesCreateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.LegalEntity],
      });
      // invalidate user so that the legal entity admin info is added to user object
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SellarUser],
      });

      // invalidate business so that associated business has legal entity updated
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
      });
    },
  });
};
